import React from 'react';
import './FirstSection.css';

const FirstSection = () => {
  return (
    <section className="first-section">
      <div className="content">
        <div className="image">
          <h2>MICROSUI</h2>
          <a href="https://movepump.com/token/0xc79f42d8d9b847797a97ff6cae71fd2ee60e35ddb0f60d14f63d64efe1907351::micro::MICRO" target='_blank' rel="noopener noreferrer">
            <div className='image-container' />
          </a>
          <h3>Look who's cooking on SUI, now you can cook too!</h3>
        </div>
      </div>
    </section>
  );
};

export default FirstSection;
